export default "/images/hy-room-tour-mobile.png?31a9886b5f6074e9fc518ae9f5146c7b";